// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"yu_a zu_sr zu_cw zu_a","MenuItem__Btn":"yu_b zu_z"};